/**
 * VÉRAULT · Time formatting (Wave 11m)
 *
 * Canonical format across the entire portal is US-standard 12h: "8:00 PM".
 *
 * Two helpers:
 *   • formatTime12h(value)     — display formatter. Accepts 24h ("20:00"),
 *     12h ("8:00 PM"), short ("8pm"), or null. Returns canonical 12h or "".
 *   • normalizeTimeInput(value) — for inputs that should canonicalize on
 *     blur. Same logic as formatTime12h but returns the original string
 *     when it's not parseable (so the user can keep typing).
 */
const RE_24H = /^\s*([01]?\d|2[0-3]):([0-5]\d)\s*$/;
const RE_12H = /^\s*(1[0-2]|[1-9])(?::([0-5]\d))?\s*([APap])\.?\s*[Mm]\.?\s*$/;

export function formatTime12h(value) {
  if (value === null || value === undefined || value === "") return "";
  if (typeof value !== "string") return String(value);
  const s = value.trim();
  if (!s) return "";
  const low = s.toLowerCase();
  if (low === "noon") return "12:00 PM";
  if (low === "midnight" || low === "00:00") return "12:00 AM";
  const m12 = s.match(RE_12H);
  if (m12) {
    const h = parseInt(m12[1], 10);
    const mm = parseInt(m12[2] || "0", 10);
    const ap = m12[3].toUpperCase() + "M";
    return `${h}:${String(mm).padStart(2, "0")} ${ap}`;
  }
  const m24 = s.match(RE_24H);
  if (m24) {
    const h = parseInt(m24[1], 10);
    const mm = parseInt(m24[2], 10);
    const ap = h < 12 ? "AM" : "PM";
    const h12 = h % 12 || 12;
    return `${h12}:${String(mm).padStart(2, "0")} ${ap}`;
  }
  return s;
}

export function normalizeTimeInput(value) {
  const out = formatTime12h(value);
  return out || value || "";
}

/**
 * Pretty range. "8:00 PM" + "10:15 PM" → "8:00 PM – 10:15 PM"
 * If end_time is empty / falsy, returns just the start formatted.
 */
export function formatTimeRange(start, end) {
  const a = formatTime12h(start);
  if (!end) return a;
  const b = formatTime12h(end);
  if (!a) return b;
  if (!b) return a;
  return `${a} – ${b}`;
}
